import { render, staticRenderFns } from "./ModalQuickRegisterLogin.vue?vue&type=template&id=4c37fe3a"
import script from "./ModalQuickRegisterLogin.vue?vue&type=script&lang=js"
export * from "./ModalQuickRegisterLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports